import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MessageData } from "../types/message";

interface IMessageFilters {
  selectedStatus: string[];
  selectedTopic: string[];
  limit: string | number;
  page: string | number;
  searchValue: string;
}

interface DemoState {
  count: number;
  conversationList: MessageData[];
  messageFilters: IMessageFilters;
}

const initialState: DemoState = {
  count: 0,
  conversationList: [],
  messageFilters: {
    selectedStatus: ["OPEN", "CLOSED"],
    selectedTopic: [],
    limit: 15,
    page: 1,
    searchValue: "",
  },
};

const messageSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setMessageCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    setConversationList: (state, action: PayloadAction<MessageData[]>) => {
      state.conversationList = action.payload;
    },
    setSelectedPage: (state, action: PayloadAction<number>) => {
      state.messageFilters.page = action.payload;
    },
    setSelectedStatus: (state, action: PayloadAction<string[]>) => {
      state.messageFilters.selectedStatus = action.payload;
    },
    setSelectedTopic: (state, action: PayloadAction<string[]>) => {
      state.messageFilters.selectedTopic = action.payload;
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.messageFilters.searchValue = action.payload;
    },
    resetFilters: (state) => {
      state.messageFilters = initialState?.messageFilters;
    },
  },
});

export const {
  setMessageCount,
  setConversationList,
  setSelectedPage,
  setSelectedStatus,
  setSelectedTopic,
  setSearchValue,
  resetFilters,
} = messageSlice.actions;

export default messageSlice.reducer;
